/**
 * ListSidebar.jsx - ListSidebar - Sidebar showing all lists
 * 
 * CHANGE HISTORY:
 * - 251018_1327 [43ebfec] danielbeer: refactor: restructure packages - extract all nested packages to top level
 */
import React, { useState } from 'react';
import { useOrganizr } from '../src/OrganizrContext';

const ListSidebar = ({
  lists,
  selectedListId,
  searchQuery,
  onSearchChange,
  onSelectList,
  onCreateList,
  onDeleteList
}) => {
  return (
    <div className="organizr-sidebar">
      <div className="organizr-sidebar-header">
        <h2>Lists</h2>
        <button onClick={onCreateList} className="btn-new-list" title="New List (Cmd+N)">
          +
        </button>
      </div>
      
      <div className="organizr-search">
        <input
          type="text"
          placeholder="Search lists..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="organizr-search-input"
        />
      </div>
      
      <div className="organizr-list-items">
        {lists.map(list => (
          <div
            key={list.id}
            className={`organizr-list-item ${selectedListId === list.id ? 'selected' : ''}`}
            onClick={() => onSelectList(list.id)}
          >
            <span className="list-item-icon" style={{ color: list.color }}>
              {list.icon}
            </span>
            <span className="list-item-name">{list.name}</span>
            <span className="list-item-count">{list.children?.length || 0}</span>
            <button
              className="list-item-delete"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteList(list.id);
              }}
              title="Delete"
            >
              ×
            </button>
          </div>
        ))}
      </div>
      
      {lists.length === 0 && (
        <div className="organizr-sidebar-empty">
          <p>No lists yet</p>
          <button onClick={onCreateList} className="btn-create-first">
            Create First List
          </button>
        </div>
      )}
    </div>
  );
};

export default ListSidebar;
